'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('preferences', {
      url: '/preferences',
      template: '<preferences></preferences>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/preferences/preferences.routes.js